module.exports = __webpack_public_path__ + "media/Video 90.f14e84b2.mp4";